// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"PageLayout-module--mainContent--22Qz1","notice":"PageLayout-module--notice--3wOhS"};